import { Expose } from 'class-transformer';
import { LanguagesEnum } from '../../../../store/support-management/SupportTypes';

export class CategoryResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'code' })
  code: string;
  @Expose({ name: 'active' })
  active: boolean;
  @Expose({ name: 'language_code' })
  languageCode: LanguagesEnum;
  @Expose({ name: 'location_id' })
  locationId: number;
  @Expose({ name: 'icon' })
  icon: string;
}
